import { render, staticRenderFns } from "./item.vue?vue&type=template&id=c41cfb2c&"
import script from "./item.vue?vue&type=script&lang=ts&"
export * from "./item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports